<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
</script>

<template>
  <div class="bg-gray-50 min-h-screen">
    <index-navbar />

    <section class="header py-8 pt-24">
      <div class="container mx-auto px-4 max-w-3xl">

        <!-- Contact部分 -->
        <div class="bg-white rounded-xl shadow-md p-8 mb-8">
          <h2 class="font-bold text-4xl text-blue-800 mb-6 pb-2 border-b-2 border-blue-100">Contact Us</h2>

          <p class="text-2xl text-gray-700 leading-relaxed mb-4">
            Please contact the head via email:
            <a href="mailto:xbioinfo@stu.scau.edu.cn" class="text-blue-600 underline">xbioinfo@stu.scau.edu.cn</a>
            or
            <a href="mailto:2959437178@qq.com" class="text-blue-600 underline">2959437178@qq.com</a>,
            thanks for your valuable suggestions.
          </p>

          <h3 class="font-bold text-3xl text-gray-800 mt-6 mb-4">Corresponding Institutions</h3>
          <ul class="list-disc list-inside text-2xl text-gray-700 space-y-2">
            <li>College of Marine Sciences, South China Agricultural University, Guangzhou, Guangdong, 510642, China</li>
            <li>Guangdong University of Technology, Guangzhou, Guangdong, China</li>
            <li>Key Laboratory of Gene Engineering of the Ministry of Education, Institute of Healthy Aging Research, School of Life Sciences, Sun-Yat-sen University, Guangzhou, Guangdong, 510006, China</li>
          </ul>
        </div>

      </div>
    </section>

    <footer-component />
  </div>
</template>

<style scoped>
.header {
  background: linear-gradient(to bottom, #f8fafc, #e2e8f0);
  min-height: 100vh;
}

.container {
  max-width: 1200px;
}
</style>
